export default "__VITE_ASSET__Cq8qXYE2__"